// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"adab92c9","496":"281a9fa1","513":"38e1c135"}[chunkId] + ".chunk.js";
};